import React, { useState, useEffect, Fragment, useRef, createRef } from 'react';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import ButtonWithIcon from 'components/sales/buttons/buttonWithIcon/buttonWithIcon';
import FormSection from 'components/sales/formSection/formSectionNew';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import Regex from 'services/utils/regex/Regex';
const ProductMasterInventoryEdit = ({
  data,
  handleValue = null,
  leadId,
  getMaterial,
  getMateriaById,
  getBrand,
  getBrandById,
  handleDataFilter = null,
  handleremoveValue = null,
  prefilledData = null,
  commData,
  prefilledDataForEdit = null
}) => { 
  // console.log('Base Price Page Call Edit');
 const objInput = { category_id: '',category_name:'', material_id: '',material_name:'', quantity: '',brand_id: '',brand_name:'', specification:'', item_price_per_qty: '', sale_unit_price:'', freez:0};
  const [inputList, setInputList] = useState([]);
  const [inputListData1, setInputListData1] = useState('');
  const [inputListData2, setInputListData2] = useState('');
  const [inputListData3, setInputListData3] = useState('');
  const [inputListData4, setInputListData4] = useState('');
  const [inputListData5, setInputListData5] = useState('');
  const [inputListData6, setInputListData6] = useState('');
  const [inputListData7, setInputListData7] = useState('');
  const [inputValue, setInputValue] = useState([objInput]);
  const [editInput, setEditInput] = useState([]);
  const [isCurrentRef, setIsCurrentRef] = useState(0);
  const [isError, setIsError] = useState(false);
  const [catVal, setCatVal] = useState('');
  const [catId, setCatId] = useState('');
  const [brandId, setBrandId] = useState('');
  const [numberVal, setNumberVal] = useState('');
  const inputRef = useRef([]);
  const [gateData, setGateData] = useState([]);
  const [materialData, setMaterialData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isEditData, setIsEditData] = useState(false);
  const [brandData, setBrandData] = useState([]);
  const [leadTypeIdVal, setLeadTypeId] = useState('');
  const [commTypeIdVal, setCommTypeId] = useState('');
  const [subAmount, setSubAmount] = useState(0);
  useEffect(() => {
    if(commData !== null) {
      var leadTypeId, commTypeId;
      if(commData?.lead_data?.lead_type_id !== undefined) {
        leadTypeId = commData?.lead_data?.lead_type_id;
      } 
      if(commData?.leadSubType !== undefined) {
        leadTypeId = commData?.leadSubType;
      }
      commTypeId = commData?.commercialData?.commercial_type_id;
      setLeadTypeId(leadTypeId);
      setCommTypeId(commTypeId);
    }
  },[commData]);
  useEffect(() => { 
    // console.log('Prefilled Data edit' + JSON.stringify(prefilledDataForEdit));
      if (
        prefilledDataForEdit !== undefined &&
        prefilledDataForEdit !== null && 
        prefilledDataForEdit.length > 0
      ) {
        if (prefilledDataForEdit != '') {
          let prod_length=prefilledDataForEdit.length;
            setInputValue(prefilledDataForEdit);
            setEditInput(prefilledDataForEdit);
            setInputListData1(prefilledDataForEdit[prod_length-1]['category_name']);
            setInputListData2(prefilledDataForEdit[prod_length-1]['quantity']);
            setInputListData3(prefilledDataForEdit[prod_length-1]['material_name']);
            setInputListData4(prefilledDataForEdit[prod_length-1]['brand_name']);
            
            if (prod_length > 1) {
              setIsEditData(true);
              setInputList([...inputList, { id: prod_length-1 }]);
            }
          // console.log('out');
          // console.log(inputValue);
        }
      } else {
        setInputValue([objInput]);
      }
    }, [prefilledDataForEdit]);
  useEffect(() => {
    setTimeout(() => {
        if (
        prefilledData?.material_hardware !== undefined &&
        prefilledData?.material_hardware !== null
        ) {
        const {
            material,
            prod_array
        } = prefilledData?.material_hardware;
        // console.log(prod_array);
        if (prod_array != '') {
            // let init = 0;
            let prod_length=prod_array.length;
            // const list = [...inputValue];
            // console.log(prod_array);
            // console.log('setting values');
            setInputValue(prod_array);
            // console.log(prod_array);
            setEditInput(prod_array);
            setInputListData1(prod_array[prod_length-1]['category_name']);
            setInputListData2(prod_array[prod_length-1]['quantity']);
            setInputListData3(prod_array[prod_length-1]['material_name']);
            setInputListData4(prod_array[prod_length-1]['brand_name']);
            
            if (prod_length > 1) {
                setIsEditData(true);
                setInputList([...inputList, { id: prod_length-1 }]);
            }
            // console.log('out');
            // console.log(inputValue);
        }
        }
    }, 1)
  }, [prefilledData]);
  const handleData = () => {
    if (data) {
      setGateData(data);
    }
  };
  useEffect(() => {
    if (data && data.length > 0) {
      handleData();
    }
  }, [data]);
  const addGates = () => {
    if (
      !inputListData1 ||
      !inputListData2 ||
      !inputListData3 ||
      !inputListData4 ||
      isError
      // !inputListData1.length ||
      // !inputListData2.length ||
      // !inputListData3.length
    ) {
      // console.log(inputListData1+' 2 '+inputListData2+' 3 '+inputListData3+' 4 '+isError);
      setIsError(true);
      return false;
    }
    setInputValue([
      ...inputValue,
      { category_id: '',category_name:'', material_id: '',material_name:'', quantity: '',brand_id: '',brand_name:'', specification:'', item_price_per_qty: '', sale_unit_price:'', freez:false, additional: 'new-item__ui'},
    ]);
    // if (inputListData1?.id) {
    if (inputListData1) {
      if (handleDataFilter) {
        handleDataFilter(inputValue);
      }
    }
    setInputList([...inputList, { id: Math.floor(Math.random() * 100) }]);
    setIsError(false);
    setInputListData1('');
    setInputListData2('');
    setInputListData3('');
    setInputListData4('');
    setInputListData5('');
    setInputListData6('');
    setInputListData7('');
  };
  const removeGate = (index = null) => {
    // console.log(inputValue[index]);
    setInputListData1(inputValue[index]?.category_id);
    setInputListData2(inputValue[index]?.quantity);
    setInputListData3(inputValue[index]?.material_id);
    setInputListData4(inputValue[index]?.brand_id);
    setInputListData5(inputValue[index]?.specification);
    setInputListData6(inputValue[index]?.item_price_per_qty);
    setInputListData7(inputValue[index]?.sale_unit_price);
    let removeArray = inputValue.splice(index, 1);
    // console.log(removeArray);
    inputList.splice(index, 1);
    setInputValue([...inputValue]);
    setInputList([...inputList]);
    if (handleremoveValue) {
      handleremoveValue(removeArray);
    }
  };
  const handleInitalValue = () => {
    setCatVal('');
    setNumberVal('');
    setInputValue([objInput]);
    if (handleremoveValue) {
      handleremoveValue([]);
    }
  };
  const handleFormData = () => {
    if (inputValue) {
      handleValue({
        productData: inputValue,
      });
    } else {
      handleValue(null);
    }
  };
  useEffect(() => {
    handleFormData();
  }, [inputValue]);
  useEffect(() => {
    if (catId) {
      (async () => {
        setIsLoading(true);
        await getBrandById(catId);
        await getMateriaById(catId);
        setIsLoading(false);
      })();
    }
  }, [catId]);
  useEffect(() => {
    if (brandId) {
      (async () => {
        setIsLoading(true);
        // console.log(brandId)
        await getMateriaById(catId,brandId);
        setIsLoading(false);
      })();
    }
  }, [brandId]);
  useEffect(() => {
    if (getBrand) {
      // console.log(getBrand)
      setBrandData(getBrand);
    }
  }, [getBrand]);
  useEffect(() => {
    if (getMaterial) {
      setMaterialData(getMaterial);
    }
  }, [getMaterial]);
  const handleInputValue = (val, key, index, isnew) => {
    // console.log(index);
    const list = [...inputValue];
    // console.log(list);
    // console.log(index);
    // console.log(key);
    list[index][key] = val;
    if(isnew !== '' && isnew !== undefined) {
        list[index]['item_price_per_qty'] = val;
    }
    setInputValue([...list]);
  };
  // handleBrandChange
  const handleBrandChange = (val, key, index) => {
   
  };
  useEffect(() => {
    if(inputValue !== undefined && inputValue?.length > 0) {
       let amt = 0;
       inputValue.map((value) => {
         if(value.quantity !== '' && value.sale_unit_price !== '') {
            amt += parseFloat(value.quantity) * parseFloat(value.sale_unit_price);
         }
       });
       setSubAmount(amt);
    }
 },[inputValue]);
 const handleOnChangeMatCatAndBrand = (index,key) => {
  //  console.log(index + ' <<< - >>>' + key);
 }
  return (
    <Fragment>
      <FormSection title={localization.productInventory} isLoading={isLoading}>
       <>
       {commTypeIdVal === 5 && <div className='mb-4 d-block__align'><b>Total Amount : </b> {subAmount}</div>}
       {inputValue && inputValue.map((value,index) => {
         return (
              <div key={index} className="w-100 row mx-0">
              <div className={`row mx-0 main-div__layout__v2 ${value?.additional}`} ref={inputRef.current[index]}>
                <div className='col-md-3'>
                  <DropDownInput
                    label={localization.selectCategory}
                    data={gateData}
                    disabled={value?.freez ?? 0}
                    getIdValue={(val) => {
                      setInputListData1(val.value);
                      setIsCurrentRef(index);
                      setCatId(val.id);
                      handleInputValue(val.id, 'category_id', index);
                      handleOnChangeMatCatAndBrand(index,'category_id');
                    }}
                    value={value.category_name}
                    required
                    isStarRequired={true}
                  />
                </div>
                <div className='col-md-3'>
                  <DropDownInput
                    label={localization.selectBrand}
                    data={brandData}
                    disabled={value?.freez ?? 0}
                    getIdValue={(val) => {
                      setIsCurrentRef(index);
                      setBrandId(val.id)
                      setInputListData4(val.value);
                      handleInputValue(val.id, 'brand_id', index);
                      handleBrandChange(val.id,'brand_id',index);
                      handleOnChangeMatCatAndBrand(index,'brand_id');
                    }}
                    value={value?.brand_name}
                    errorMsg={localization.isRequired}
                    required
                    isStarRequired={true}
                  />
                
              </div>
                <div className='col-md-3'>
                  {/* {value.category_id && ( */}
                  <DropDownInput
                    label={localization.selectMaterial}
                    disabled={value?.freez ?? 0}
                    data={materialData.length === 0 ? [] : materialData}
                    getIdValue={(val) => {
                      setIsCurrentRef(index);
                      setInputListData3(val.value);
                      handleInputValue(val.id, 'material_id', index);
                      handleOnChangeMatCatAndBrand(index,'material_id');
                    }}
                    errorMsg={localization.isRequired}
                    required
                    isStarRequired={true}
                    value={value.material_name}
                    title={value?.material_name}
                  />
                {/* )} */}
                </div>
                <div className='col-md-3'>
                  <ConstantInput
                    label={localization.quantity}
                    // disabled={(leadTypeIdVal === 1 && commTypeIdVal === 5) ? true : false}
                    // disabled={value?.freez}
                    type="number"
                    min={1}
                    handleChange={(val) => {
                      setInputListData2(val);
                      setIsCurrentRef(index);
                      handleInputValue(val, 'quantity', index);
                      setIsError(
                        !Regex.numericNotZero.test(
                          value?.quantity
                        )
                      );
                    }}
                    value={value?.quantity ?? ''}
                    required
                    isStarRequired={true}
                  />
                </div>
                {commTypeIdVal === 5 &&
                  <>
                  <div className='col-md-2'>
                    <ConstantInput
                      label={`Base Unit Price`}
                      type="number"
                      min={1}
                      disabled={true}
                      handleChange={(val) => {
                        setInputListData6(val);
                        setIsCurrentRef(index);
                        handleInputValue(val, 'item_price_per_qty', index);
                        setIsError(
                          !Regex.numericNotZero.test(
                            inputValue[index]?.item_price_per_qty
                          )
                        );
                      }}
                      // required
                      // isStarRequired={true}
                      value={value?.item_price_per_qty ?? 0}
                    />
                  </div>
                  <div className='col-md-2'>
                    <ConstantInput
                      label={`Sale Unit Price`}
                      type="number"
                      min={0}
                      handleChange={(val) => {
                        const newValue = Math.max(0, Number(val || 0));
                        setInputListData7(newValue);
                        setIsCurrentRef(index);
                        handleInputValue(newValue, 'sale_unit_price', index, value?.additional);
                        //setIsError(!Regex.numericNotZero.test(inputValue[index]?.sale_unit_price));
                        }}
                        // required
                        // isStarRequired={true}
                        value={Math.max(0, Number(value?.sale_unit_price || 0))}
                    />
                  </div>
                  <div className='col-md-2'>
                    <ConstantInput
                      label={`Price Variation`}
                      type="number"
                      value={Number(value?.sale_unit_price || 0) - Number(value?.item_price_per_qty || 0)}
                      disabled={true}
                    />
                  </div>
                  </>
                }
                <div className='col-md-3'>
                    <ConstantInput
                    label={localization.specification}
                    
                    type="text"
                    value={value?.specification ?? ''}
                    handleChange={(val) => {
                      // setNumberVal(val);
                      setInputListData5(val);
                      setIsCurrentRef(index);
                      handleInputValue(val, 'specification', index);
                      
                    }}
                    
                  />
                </div>
                {inputValue?.length > 0 && inputValue?.length !== 1 && 
                    <div className='col-md-3'>
                        <ButtonWithIcon
                            cls="btn btn-danger"
                            title="Remove"
                            onClick={() => removeGate(index)}
                        />
                   </div>
               }
               <div>
                  <br />
                  <br />
                </div>
              </div>
            </div>
         )
       })
       }
     </>
 
        {/* <span>
          {isError ? (
            <label className="error d-block">{localization.enterField}</label>
          ) : null}
        </span> */}
        <div className="w-100">
          <ButtonWithIcon
            title={localization.addMoreGates}
            onClick={addGates}
          />
        </div>
      </FormSection>
    </Fragment>
  );
};
export default ProductMasterInventoryEdit;